

const initialState = {
  isLoading: false,
  bank: {},
  banklist: {},
  currentData: {},

  errors: null,
};

const bankDetailreducers = (state = initialState, action) => {
  switch (action.type) {
    case "banklist_req":
      return {
        ...state,
        isLoading: true,
      };
    case "bankList_success":
      return {
        ...state,
        isLoading: false,

        banklist: action.payload,
      };
    case "bankList_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "delete_bank_req":
      return {
        ...state,
        isLoading: true,
      };
    case "delete_bank_success":
      return {
        ...state,
        isLoading: false,

        banklist: action.payload,
      };
    case "delete_bank_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "add_bank_req":
      return {
        ...state,
        isLoading: true,
      };
    case "add_bank_success":
      return {
        ...state,
        isLoading: false,

        bank: action.payload,
      };
    case "add_bank_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "edit_bank_req" || "edit_bank_req2":
      return {
        ...state,
        isLoading: true,
      };
    case "edit_bank_success" || "edit_bank_success2":
      return {
        ...state,
        isLoading: false,

        bank: action.payload,
      };

    case "edit_bank_failure" || "edit_bank_failure2":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "set_bank_details":
      return {
        ...state,
        laoding: false,
        currentData: action.payload,
      };
    case "reset_facility_details":
      return {
        ...state,
        laoding: false,
        currentData: {},
      };

    default:
      return state;
  }
};

export { bankDetailreducers };
